module.exports = __webpack_public_path__ + "img/square-fill.7774748e.svg";